import React from "react";
import { OverlayTrigger, Tooltip as ToolTipComponent } from "react-bootstrap";

const TooltipWrapper = ({
  isMobile,
  className = "",
  trigger = ["hover", "focus"],
  placement = "bottom",
  delay = { show: 250, hide: 200 },
  flip = true,
  tooltipId,
  tooltipContent,
  children,
}) => {
  const triggerArray = Array.isArray(trigger) ? trigger : [trigger];
  const wrappedChild =
    React.Children.count(children) === 1
      ? React.Children.only(children)
      : <span className="tooltip-trigger-wrapper">{children}</span>;

  const childElement = React.isValidElement(wrappedChild)
    ? React.cloneElement(wrappedChild, {
        tabIndex: wrappedChild.props?.tabIndex ?? 0,
        "aria-describedby": tooltipId,
        className: `${wrappedChild.props?.className ?? ""}`.trim(),
      })
    : wrappedChild;

  return (
    <div className={className}>
      <OverlayTrigger
        placement={placement}
        delay={delay}
        flip={flip}
        trigger={triggerArray}
        overlay={
          <ToolTipComponent
            className={`${tooltipId==='est-info-tooltip'?'est-tooltip' :'apy-tooltip'} inter ${isMobile ? "mobile-tooltip" : ""}`}
            id={tooltipId}
            role="tooltip"
          >
            {tooltipContent}
          </ToolTipComponent>
        }
        rootClose={true}
      >
        {childElement}
      </OverlayTrigger>
    </div>
  );
};

const Tooltip = ({ isMobile, tooltipText, tooltipId, children }) => {
  const triggers = isMobile ? ["click", "focus"] : ["hover", "focus", "click"];

  return (
    <TooltipWrapper
      isMobile={isMobile}
      className="d-flex align-items-center"
      trigger={triggers}
      tooltipId={tooltipId}
      tooltipContent={tooltipText}
    >
      {children}
    </TooltipWrapper>
  );
};

export default Tooltip;
